import { render, staticRenderFns } from "./headersP.vue?vue&type=template&id=ab568f0c&scoped=true&"
import script from "./headersP.vue?vue&type=script&lang=js&"
export * from "./headersP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab568f0c",
  null
  
)

export default component.exports